<template>
  <div class="dashboard-form-submissions">
    <h2>Dashboard Form Submissions</h2>
    <div class="md-layout md-alignment-top-left">
      <div class="query-container md-layout-item md-small-size-100 md-size-35">
        <md-field>
          <label>
            {{ 'Search ' + filteredSubmissions.length + ' submissions'}}
          </label>
          <md-input v-model="query"></md-input>
        </md-field>

        <div class="result-container">
          <md-empty-state
            v-show="filteredSubmissions.length==0"
            :md-label="emptyStateLabelText"
            :md-description="emptyStateDescriptionText"
          />
          <div
            v-show="filteredSubmissions.length>0"
            v-for="submission in filteredSubmissions"
            :key="submission.id"
            class="md-layout md-alignment-top-left"
          >
            <router-link
              v-if="submission.content"
              :to="makeFormSubmissionUrl(submission.id)"
              class="submission-list-item"
            >
              <div class="md-layout-item md-size-65">
                <div class="title">
                  {{submission.content.email}}
                </div>
              </div>
              <div class="md-layout-item md-size-35">
                {{new Date(submission.created_at).toLocaleDateString()}}
              </div>
            </router-link>
          </div>
        </div>

      </div>
      <div class="md-layout-item md-small-size-100 md-size-65" >
        <router-view></router-view>
        <md-empty-state
          v-show="submission_id === null || submission_id === undefined"
          md-label="No submission selected"
          md-description="Select a submission on the left to show its content."
        />
      </div>
    </div>

  </div>
</template>

<script>
import Vue2Filters from 'vue2-filters'

export default {
  name: 'DashboardFormSubmissions',
  mixins: [Vue2Filters.mixin],
  data () {
    return {
      query: ''
    }
  },
  mounted () {
    this.fetchSubmission()
  },
  watch: {
    submission_id (newValue) {
      this.fetchSubmission()
    }
  },
  computed: {
    form_id () {
      return this.$route.params.form_id
    },
    submission_id () {
      return this.$route.params.submission_id
    },
    form () {
      return this.$store.getters['currentForm']
    },
    submission () {
      return this.$store.getters['currentSubmission']
    },
    submissions () {
      return this.form.submissions
    },
    filteredSubmissions () {
      return this.filterBy(this.submissions, this.query)
    },
    emptyStateLabelText () {
      if (this.submissions.length === 0) {
        return 'No submissions yet'
      } else if (this.filteredSubmissions.length === 0) {
        return 'No matching submissions'
      }
      return ''
    },
    emptyStateDescriptionText () {
      if (this.submissions.length === 0) {
        return 'This form has not received any submissions yet.'
      } else if (this.filteredSubmissions.length === 0) {
        return `There are no submissions matching your query '${this.query}'.`
      }
      return ''
    }
  },
  methods: {
    async fetchSubmission () {
      try {
        this.$store.dispatch('fetchCurrentSubmission', this.submission_id)
      } catch (error) {
        window.log.debug(error)
      }
    },
    makeFormSubmissionUrl (path) {
      return '/forms/' + this.form_id + '/submissions/' + path
    }
  }
}
</script>

<style lang="scss" scoped>
 @import '../../assets/theme.scss';

.md-field {
  margin-right: 15px;
  width: calc(100% - 15px);
}
.submission-list-item {
  width: 100%;
  margin-bottom: 10px;
  margin-right: 15px;
  padding: 10px;
  border-radius: 8px;
  background-color: whitesmoke;
  text-decoration: none !important;
}
.submission-list-item:hover{
  background-color: $primary;
  color: white !important;
}
.title {
  font-weight: bold;
}
.query-container {
  height: calc(100vh - 265px);
  max-height: calc(100vh - 265px);
  overflow-y: auto;
  padding-right: 32px;
}
.result-container {
  max-height: calc(100% - 76px);
  overflow-y: auto;
}

@media screen and (max-width: 960px) {
  .query-container {
    height: 220px;
    max-height: 220px;
    margin-bottom: 30px;
    padding-right: 0;
  }
  .query-container .md-field {
    margin-bottom: 4px;
  }

  .result-container {
    max-height: calc(100% - 48px);
  }
  .md-field {
    width: 100%;
    margin-right: 0;
  }
  .submission-list-item  {
    font-size: 13px;
    margin-right: 0;
    padding: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/DashboardFormSubmissions.vue